import { atom } from "jotai";
import { userAtom } from "./auth.atoms";
import type { SelfHostConnection } from "@/services/self-host.service";

export type BroadcastTarget = "cloud" | "self-host";
export const broadcastTargetAtom = atom<BroadcastTarget>("cloud");

// Credentials live only in memory, scoped to the signed-in user; never persisted.
const connectionAtom = atom<{
  userId: number;
  connection: SelfHostConnection;
} | null>(null);
export const selfHostConnectionAtom = atom(
  (get) => {
    const saved = get(connectionAtom);
    return saved?.userId === get(userAtom)?.id
      ? (saved?.connection ?? null)
      : null;
  },
  (get, set, connection: SelfHostConnection | null) => {
    const userId = get(userAtom)?.id;
    set(connectionAtom, connection && userId ? { userId, connection } : null);
  },
);
